module.exports = __webpack_public_path__ + "img/12-4.d99bb847.png";